import { Colors } from "@/components/common";

const peiAtServiceStatus = {
  PendienteAnalisis: 1,
  PendienteDeterminacion: 2,
  Denegado: 3,
  PendienteDeCita: 4,
  PendienteDeEvaluacion: 5,
  PendienteDeRecoordinarCita: 6,
  Ajustado: 7,
  PendienteDeDiscusion: 8,
  PendienteDeRequisicion: 9,
  PendienteDeCompra: 10,
  PendienteDeEntregaCSEE: 11,
  PendienteDeEntregaEscuela: 12,
  PendienteDeDiscusionEscuela: 13,
  Servido: 14,
  PendienteDeValidacion: 15,
  PendienteDeAvaluo: 16,
  PendienteAnalisisRequisicion: 17,
  PendienteDeDocumentacion: 18,
  PendienteDeServicio: 22,
  Realizado: 23,
  PendienteDeClasificacion: 21,
  DiscutidoPendienteDeFirma: 25,
  EntregadoPendienteFirma:26
};

const getStatusColor = statusId => {
  let colorName = "";
  switch (statusId) {
    case peiAtServiceStatus.Servido:
      colorName = Colors.GREEN_LIGHT;
      break;
    case peiAtServiceStatus.PendienteAnalisis:
    case peiAtServiceStatus.DiscutidoPendienteDeFirma:
      colorName = Colors.PINK;
      break;
    case peiAtServiceStatus.Ajustado:
    case peiAtServiceStatus.Denegado:
      colorName = Colors.BROWN;
      break;
    case peiAtServiceStatus.PendienteDeterminacion:
    case peiAtServiceStatus.PendienteDeCita:
    case peiAtServiceStatus.PendienteDeEvaluacion:
    case peiAtServiceStatus.PendienteDeRecoordinarCita:
    case peiAtServiceStatus.PendienteDeRequisicion:
    case peiAtServiceStatus.PendienteDeCompra:
    case peiAtServiceStatus.PendienteDeEntregaCSEE:
    case peiAtServiceStatus.PendienteDeEntregaEscuela:
    case peiAtServiceStatus.PendienteDeValidacion:
    case peiAtServiceStatus.PendienteDeAvaluo:
    case peiAtServiceStatus.PendienteAnalisisRequisicion:
    case peiAtServiceStatus.PendienteDeDocumentacion:
    case peiAtServiceStatus.PendienteDeClasificacion:
    case peiAtServiceStatus.PendienteDeServicio:
      colorName = Colors.YELLOW;
      break;
    case peiAtServiceStatus.PendienteDeDiscusionEscuela:
    case peiAtServiceStatus.PendienteDeDiscusion:
    case peiAtServiceStatus.EntregadoPendienteFirma: 
      colorName = Colors.CHARDONNAY;
      break;
    default:
      break;
  }

  return colorName;
};

export { peiAtServiceStatus, getStatusColor };
